import React, { useState } from 'react';
import { Container, Card, Form, Button, Row, Col, Alert, Badge, Spinner, InputGroup } from 'react-bootstrap';
import { 
    FaUserTie, FaServer, FaShieldAlt, FaArrowRight, FaDownload, 
    FaVideo, FaCopy, FaMicrochip, FaGlobe, FaMobileAlt, FaChevronRight 
} from 'react-icons/fa';
import api from '../services/api';

const ResourceHub = ({ setCurrentView }) => {
    const [showAgencyForm, setShowAgencyForm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);
    
    const [form, setForm] = useState({
        requestedAgencyName: '', platform: 'facebook', channelName: '',
        description: '', targetMonthlyUsers: 10, idCardFront: null, idCardBack: null
    });

    const handleCopyCode = (code, label) => {
        navigator.clipboard.writeText(code);
        alert(`✅ Đã copy mã giới thiệu ${label}: ${code}`);
    };

    const handleFileChange = (e, field) => {
        const file = e.target.files[0];
        if (file) setForm({ ...form, [field]: file });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        const formData = new FormData();
        Object.keys(form).forEach(key => formData.append(key, form[key]));
        try {
            const res = await api.post('/auth/submit-agency-request', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            if (res.data.success) {
                setMessage("Đơn đăng ký đối tác đã được gửi! Chúng tôi sẽ liên hệ trong 24h.");
                setTimeout(() => setShowAgencyForm(false), 5000);
            }
        } catch (err) {
            setError(err.response?.data?.message || "Lỗi hệ thống.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container fluid className="py-5 px-lg-5" style={{ background: '#020617', minHeight: '100vh', color: '#fff' }}>
            
            {/* HEADER */}
            <div className="text-center mb-5 pb-4 position-relative">
                <div className="position-absolute" style={{ top: '-50px', left: '50%', transform: 'translateX(-50%)', width: '300px', height: '100px', background: 'rgba(234, 179, 8, 0.1)', filter: 'blur(80px)', zIndex: 0 }}></div>
                <Badge bg="none" className="mb-4 px-4 py-2 text-gold-highlight border border-warning border-opacity-50 rounded-pill font-mono shadow-glow text-uppercase" style={{ letterSpacing: '3px', fontSize: '0.75rem' }}>
                    <FaMicrochip className="me-2 animate-pulse"/> NEXBOT_RESOURCE_CENTER
                </Badge>
                
                <h1 className="fw-black text-gold-highlight text-uppercase font-main mb-3 py-2" 
                    style={{ fontSize: 'clamp(2rem, 5vw, 3.5rem)', lineHeight: '1.4', letterSpacing: '-1px' }}>
                    TRUNG TÂM NGUỒN LỰC
                </h1>
                <p className="text-white font-main mx-auto" style={{ maxWidth: '600px', opacity: 0.8 }}>
                    Tải công cụ hỗ trợ và kết nối với hệ sinh thái NeXBot để tối ưu hóa lợi nhuận trên các sàn giao dịch uy tín.
                </p>
            </div>

            {/* DOWNLOAD CARDS */}
            <Row className="g-4 mb-5">
                <Col lg={4} md={6}>
                    <Card className="feature-card border-0 h-100" style={{ background: '#0b1221', border: '1px solid rgba(255,255,255,0.05)', borderRadius: '24px' }}>
                        <Card.Body className="p-4 d-flex flex-column align-items-center text-center">
                            <div className="feature-icon fs-1 mb-3 text-gold-highlight"><FaServer /></div>
                            <h3 className="text-white fw-black mb-1 font-main text-uppercase" style={{ fontSize: '1.25rem' }}>MT5 EXNESS</h3>
                            <Badge bg="none" className="text-warning font-mono mb-3">V.OPTIMIZED</Badge>
                            <p className="text-white-50 small mb-4">Tối ưu riêng cho hạ tầng Exness, đảm bảo khớp lệnh siêu tốc.</p>
                            <div className="d-grid gap-2 w-100 mt-auto">
                                <Button href="https://download.mql5.com/cdn/web/exness.technologies.ltd/mt5/exness5setup.exe" className="btn-luxury-gold py-2 fw-bold border-0">
                                    <FaDownload className="me-2"/> TẢI WINDOWS
                                </Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col lg={4} md={6}>
                    <Card className="feature-card border-0 h-100" style={{ background: '#0b1221', border: '1px solid rgba(255,255,255,0.05)', borderRadius: '24px' }}>
                        <Card.Body className="p-4 d-flex flex-column align-items-center text-center">
                            <div className="feature-icon fs-1 mb-3 text-info"><FaServer /></div>
                            <h3 className="text-white fw-black mb-1 font-main text-uppercase" style={{ fontSize: '1.25rem' }}>MT5 XM GLOBAL</h3>
                            <Badge bg="none" className="text-info font-mono mb-3">OFFICIAL_BUILD</Badge>
                            <p className="text-white-50 small mb-4">Nền tảng giao dịch XM chính thức dành cho máy tính (PC/Laptop).</p>
                            <div className="d-grid gap-2 w-100 mt-auto">
                                <Button href="https://www.xmvnmarket.com/vn/mt5" target="_blank" className="btn-outline-info py-2 fw-bold text-white border-info">
                                    <FaDownload className="me-2"/> TẢI MT5 XM
                                </Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col lg={4} md={6}>
                    <Card className="feature-card border-0 h-100" style={{ background: '#0b1221', border: '1px solid rgba(255,255,255,0.05)', borderRadius: '24px' }}>
                        <Card.Body className="p-4 d-flex flex-column align-items-center text-center">
                            <div className="feature-icon fs-1 mb-3 text-gold-highlight"><FaMobileAlt /></div>
                            <h3 className="text-white fw-black mb-1 font-main text-uppercase" style={{ fontSize: '1.25rem' }}>ỨNG DỤNG XM</h3>
                            <Badge bg="none" className="text-warning font-mono mb-3">MOBILE_TRADING</Badge>
                            <p className="text-white-50 small mb-4">Quản lý tài khoản và giao dịch mọi lúc trên điện thoại qua App XM.</p>
                            <div className="d-grid gap-2 w-100 mt-auto">
                                <Button href="https://www.xm.com/xm-app" target="_blank" className="btn-luxury-gold py-2 fw-bold border-0">
                                    <FaArrowRight className="me-2"/> TẢI APP XM
                                </Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* MÃ GIỚI THIỆU & HỖ TRỢ KỸ THUẬT */}
            <Row className="g-4 mb-5">
                <Col lg={6}>
                    <Card className="feature-card border-0 h-100" style={{ background: '#0b1221', borderRadius: '24px', border: '1px solid rgba(234, 179, 8, 0.2)' }}>
                        <Card.Body className="p-4">
                            <h4 className="text-gold-highlight fw-black font-main mb-4 text-uppercase"><FaShieldAlt className="me-2"/> Đăng ký & Mã giới thiệu</h4>
                            <div className="mb-4 p-3 rounded-4" style={{ background: 'rgba(255,255,255,0.02)' }}>
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="font-mono small text-warning">SÀN EXNESS 1</span>
                                    <Button size="sm" variant="link" className="text-gold-highlight p-0 text-decoration-none" href="https://one.exnessonelink.com/a/bfoz1gnn4z" target="_blank">Link Đăng Ký <FaChevronRight size={10}/></Button>
                                </div>
                                <InputGroup>
                                    <Form.Control readOnly value="bfoz1gnn4z" className="form-control-product font-mono shadow-none" style={{ background: '#020617' }} />
                                    <Button variant="outline-warning" onClick={() => handleCopyCode('bfoz1gnn4z', 'Exness')}>
                                        <FaCopy /> Copy
                                    </Button>
                                </InputGroup>
                            </div>

                            <div className="p-3 rounded-4" style={{ background: 'rgba(255,255,255,0.02)' }}>
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="font-mono small text-info">SÀN XM</span>
                                    <Button size="sm" variant="link" className="text-info p-0 text-decoration-none" href="https://www.xmvnmarket.com/referral?token=jdKNGZkumqKVrZeH3Cm2jg" target="_blank">Link Đăng Ký <FaChevronRight size={10}/></Button>
                                </div>
                                <InputGroup>
                                    <Form.Control readOnly value="Y6HJF" className="form-control-product font-mono shadow-none" style={{ background: '#020617' }} />
                                    <Button variant="outline-info" onClick={() => handleCopyCode('Y6HJF', 'XM')}>
                                        <FaCopy /> Copy
                                    </Button>
                                </InputGroup>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col lg={6}>
                    <Card className="feature-card border-0 h-100" style={{ background: 'linear-gradient(135deg, #0b1221 0%, #1e293b 100%)', borderRadius: '24px' }}>
                      <Card.Body className="p-4">
                            <h4 className="text-gold-highlight fw-black font-main mb-4 text-uppercase"><FaShieldAlt className="me-2"/> Đăng ký & Mã giới thiệu</h4>
                            <div className="mb-4 p-3 rounded-4" style={{ background: 'rgba(255,255,255,0.02)' }}>
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="font-mono small text-warning">SÀN EXNESS 2</span>
                                    <Button size="sm" variant="link" className="text-gold-highlight p-0 text-decoration-none" href="https://one.exnessonelink.com/a/vvvmcuvr" target="_blank">Link Đăng Ký <FaChevronRight size={10}/></Button>
                                </div>
                                <InputGroup>
                                    <Form.Control readOnly value="vvvmcuvr" className="form-control-product font-mono shadow-none" style={{ background: '#020617' }} />
                                    <Button variant="outline-warning" onClick={() => handleCopyCode('vvvmcuvr', 'Exness')}>
                                        <FaCopy /> Copy
                                    </Button>
                                </InputGroup>
                            </div>

                            <div className="p-3 rounded-4" style={{ background: 'rgba(255,255,255,0.02)' }}>
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="font-mono small text-info">SÀN XM</span>
                                    <Button size="sm" variant="link" className="text-info p-0 text-decoration-none" href="https://www.xmvnmarket.com/referral?token=jdKNGZkumqKVrZeH3Cm2jg" target="_blank">Link Đăng Ký <FaChevronRight size={10}/></Button>
                                </div>
                                <InputGroup>
                                    <Form.Control readOnly value="Y6HJF" className="form-control-product font-mono shadow-none" style={{ background: '#020617' }} />
                                    <Button variant="outline-info" onClick={() => handleCopyCode('Y6HJF', 'XM')}>
                                        <FaCopy /> Copy
                                    </Button>
                                </InputGroup>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* FORM ĐĂNG KÝ ĐỐI TÁC */}
            {!showAgencyForm ? (
                <div className="text-center py-5">
                    <Button variant="warning" className="btn-luxury-gold px-5 py-3 fw-black border-0" 
                            style={{ borderRadius: '12px', letterSpacing: '1px' }}
                            onClick={() => setShowAgencyForm(true)}>
                        <FaUserTie className="me-2"/> ĐĂNG KÝ ĐỐI TÁC CHIẾN LƯỢC
                    </Button>
                </div>
            ) : (
                <Card className="mx-auto border-0 overflow-hidden shadow-2xl" 
                      style={{ maxWidth: '850px', background: '#0b1221', borderRadius: '32px', border: '1px solid rgba(234, 179, 8, 0.3)' }}>
                    <Card.Body className="p-4 p-md-5">
                        <div className="d-flex justify-content-between align-items-center mb-5">
                            <div>
                                <h2 className="text-gold-highlight fw-black mb-0 font-main text-uppercase" style={{ fontSize: '1.8rem' }}>Đăng ký Đại lý</h2>
                                <div className="small text-white opacity-50 font-mono mt-1">AGENCY_APPLICATION_FORM</div>
                            </div>
                            <button type="button" className="btn-close btn-close-white" onClick={() => setShowAgencyForm(false)}></button>
                        </div>

                        {message && <Alert variant="success">{message}</Alert>}
                        {error && <Alert variant="danger">{error}</Alert>}

                        <Form onSubmit={handleSubmit}>
                            <Row className="g-4">
                                <Col md={6}>
                                    <Form.Label className="stat-label mb-2"><FaUserTie className="me-1"/> Tên đại lý / Tổ chức</Form.Label>
                                    <Form.Control required className="form-control-product py-3" placeholder="Ví dụ: NeX Capital" onChange={(e) => setForm({...form, requestedAgencyName: e.target.value})}/>
                                </Col>
                                <Col md={6}>
                                    <Form.Label className="stat-label mb-2"><FaGlobe className="me-1"/> Nền tảng chính</Form.Label>
                                    <Form.Select className="form-control-product py-3" onChange={(e) => setForm({...form, platform: e.target.value})}>
                                        <option value="facebook">Facebook Marketing</option>
                                        <option value="telegram">Telegram Community</option>
                                        <option value="youtube">Youtube Channel</option>
                                        <option value="offline">Văn phòng trực tiếp</option>
                                    </Form.Select>
                                </Col>
                                <Col md={12}>
                                    <Form.Label className="stat-label mb-2">Mô tả kế hoạch phát triển</Form.Label>
                                    <Form.Control as="textarea" rows={4} className="form-control-product" placeholder="Hãy mô tả ngắn gọn kinh nghiệm và quy mô cộng đồng của bạn..." onChange={(e) => setForm({...form, description: e.target.value})}/>
                                </Col>
                                
                                <Col md={6}>
                                    <div className="p-4 rounded-4" style={{ background: 'rgba(15, 23, 42, 0.4)', border: '1px dashed rgba(255,255,255,0.1)' }}>
                                        <Form.Label className="stat-label mb-2">Mặt trước CCCD</Form.Label>
                                        <Form.Control type="file" className="form-control-product" onChange={(e) => handleFileChange(e, 'idCardFront')}/>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="p-4 rounded-4" style={{ background: 'rgba(15, 23, 42, 0.4)', border: '1px dashed rgba(255,255,255,0.1)' }}>
                                        <Form.Label className="stat-label mb-2">Mặt sau CCCD</Form.Label>
                                        <Form.Control type="file" className="form-control-product" onChange={(e) => handleFileChange(e, 'idCardBack')}/>
                                    </div>
                                </Col>
                            </Row>
                            <Button type="submit" className="btn-luxury-gold w-100 py-3 fw-black mt-5 text-dark" disabled={loading}>
                                {loading ? <Spinner size="sm" animation="border" /> : "GỬI HỒ SƠ XÉT DUYỆT"}
                            </Button>
                        </Form>
                    </Card.Body>
                </Card>
            )}
            
            <style>{`
                .font-main { font-family: sans-serif; }
                .font-mono { font-family: monospace; }
                .fw-black { font-weight: 900; }
                .text-gold-highlight { 
                    background: linear-gradient(135deg, #eab308 0%, #fef3c7 50%, #eab308 100%); 
                    -webkit-background-clip: text; 
                    -webkit-text-fill-color: transparent; 
                    background-clip: text; 
                }
                .btn-luxury-gold { background: linear-gradient(135deg, #eab308 0%, #fbbf24 100%) !important; color: #000 !important; }
                .feature-card:hover { border-color: #fbbf24 !important; transform: translateY(-5px); transition: 0.3s; }
                .stat-label { font-size: 0.7rem; color: #cbd5e1; text-transform: uppercase; }
                .form-control-product { background: #0f172a !important; color: #fff !important; border: 1px solid #334155 !important; }
                @keyframes pulse { 0% { opacity: 1; } 50% { opacity: 0.5; } 100% { opacity: 1; } }
                .animate-pulse { animation: pulse 2s infinite; }
            `}</style>
        </Container>
    );
};

export default ResourceHub;